

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

function header() {
  const el = $('[data-header]');
  if (!el) return;
  const seuil = () => (el.dataset.transparent === 'true' ? window.innerHeight * 0.6 : 8);
  const maj = () => el.classList.toggle('est-pose', window.scrollY > seuil());
  maj();
  addEventListener('scroll', maj, { passive: true });
}

const panneaux = new Map();

function ouvrir(id, declencheur) {
  fermerTout(id);
  const p = document.getElementById(id);
  if (!p) return;
  p.hidden = false;
  requestAnimationFrame(() => p.classList.add('est-ouvert'));
  document.documentElement.style.overflow = 'hidden';
  panneaux.set(id, declencheur || document.activeElement);
  const premier = p.querySelector('[data-fermer], a, button, input');
  premier?.focus();
  $$('[aria-controls="' + id + '"]').forEach(b => b.setAttribute('aria-expanded', 'true'));
}

function fermer(id) {
  const p = document.getElementById(id);
  if (!p || p.hidden) return;
  p.classList.remove('est-ouvert');
  const fin = () => { p.hidden = true; p.removeEventListener('transitionend', fin); };
  p.addEventListener('transitionend', fin);
  setTimeout(fin, 320);
  $$('[aria-controls="' + id + '"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
  const dec = panneaux.get(id);
  panneaux.delete(id);
  if (!panneaux.size) document.documentElement.style.overflow = '';
  dec?.focus?.();
}

function fermerTout(sauf) {
  Array.from(panneaux.keys()).forEach(id => { if (id !== sauf) fermer(id); });
}

function brancherPanneaux() {
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-ouvrir]');
    if (o) { e.preventDefault(); ouvrir(o.dataset.ouvrir, o); return; }
    const f = e.target.closest('[data-fermer]');
    if (f) { e.preventDefault(); fermer(f.closest('[data-panneau]').id); return; }
    const p = e.target.closest('[data-panneau]');
    if (p && e.target === p) fermer(p.id);
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && panneaux.size) {
      fermer(Array.from(panneaux.keys()).pop());
      return;
    }
    if (e.key !== 'Tab' || !panneaux.size) return;
    const p = document.getElementById(Array.from(panneaux.keys()).pop());
    const cibles = $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', p)
      .filter(el => el.offsetParent !== null);
    if (!cibles.length) return;
    const premier = cibles[0], dernier = cibles[cibles.length - 1];
    if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
  });
}

function megaMenu() {
  const barre = $('[data-mega]');
  if (!barre) return;
  let t;
  const fin = window.matchMedia('(hover:hover) and (min-width:990px)');
  $$('[data-mega-entree]', barre).forEach(entree => {
    const cible = entree.getAttribute('aria-controls');
    if (!cible) return;
    const montrer = () => { clearTimeout(t); if (fin.matches) ouvrir(cible, entree); };
    const cacher = () => { t = setTimeout(() => fermer(cible), 160); };
    entree.addEventListener('mouseenter', montrer);
    entree.addEventListener('mouseleave', cacher);
    entree.addEventListener('focus', montrer);
    const panneau = document.getElementById(cible);
    panneau?.addEventListener('mouseenter', () => clearTimeout(t));
    panneau?.addEventListener('mouseleave', cacher);
  });
}

function accordeons() {
  $$('[data-accordeon] .accordeon__tete').forEach(tete => {
    tete.addEventListener('click', () => {
      const ouvert = tete.getAttribute('aria-expanded') === 'true';
      tete.setAttribute('aria-expanded', String(!ouvert));
      const corps = document.getElementById(tete.getAttribute('aria-controls'));
      if (corps) corps.hidden = ouvert;
    });
  });
}

function devoilements() {
  $$('[data-accordeon-simple]').forEach(bouton => {
    const cible = document.getElementById(bouton.getAttribute('aria-controls'));
    if (!cible) return;
    bouton.addEventListener('click', () => {
      const ouvert = bouton.getAttribute('aria-expanded') === 'true';
      bouton.setAttribute('aria-expanded', String(!ouvert));
      cible.hidden = ouvert;

      if (!ouvert) bouton.hidden = true;
    });
  });
}

function videos() {
  const reduit = matchMedia('(prefers-reduced-motion:reduce)').matches;
  $$('[data-video]').forEach(bloc => {
    const v = $('video', bloc);
    if (!v) return;
    if (reduit) { v.remove(); bloc.classList.add('video--fixe'); return; }
    const io = new IntersectionObserver(entrees => {
      entrees.forEach(e => {
        if (e.isIntersecting) { v.play?.().catch(() => {}); }
        else { v.pause?.(); }
      });
    }, { threshold: 0.25 });
    io.observe(bloc);
    $('[data-video-pause]', bloc)?.addEventListener('click', ev => {
      const b = ev.currentTarget;
      if (v.paused) { v.play(); b.setAttribute('aria-label', 'Mettre la vidéo en pause'); }
      else { v.pause(); b.setAttribute('aria-label', 'Reprendre la vidéo'); }
    });
  });
}

async function rafraichirPanier() {
  try {
    const r = await fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}?section_id=cart-drawer` : '/?section_id=cart-drawer');
    if (!r.ok) return;
    const html = await r.text();
    const frais = new DOMParser().parseFromString(html, 'text/html');
    const cible = $('[data-panier-contenu]');
    const source = frais.querySelector('[data-panier-contenu]');
    if (cible && source) cible.innerHTML = source.innerHTML;
    const c = await (await fetch('/cart.js')).json();
    $$('[data-compte-panier]').forEach(el => {
      el.textContent = c.item_count;
      el.hidden = c.item_count === 0;
    });
  } catch (_) {  }
}

function panier() {
  document.addEventListener('submit', async e => {
    const f = e.target.closest('[data-ajout-panier]');
    if (!f) return;
    e.preventDefault();
    const b = $('button[type="submit"]', f);
    b?.setAttribute('disabled', '');
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', body: new FormData(f) });
      if (r.ok) { await rafraichirPanier(); ouvrir('tiroir-panier', b); }
    } finally { b?.removeAttribute('disabled'); }
  });

  document.addEventListener('click', async e => {
    const el = e.target.closest('[data-ligne-panier]');
    if (!el) return;
    e.preventDefault();
    await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: el.dataset.ligneCle, quantity: Number(el.dataset.ligneQuantite) })
    });
    rafraichirPanier();
  });

  const codesPoses = () => ($('[data-codes]')?.dataset.codes || '').split(',').filter(Boolean);
  const poserCodes = async codes => {
    const r = await fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    });
    return r.ok ? r.json() : null;
  };
  const dire = (texte, depuis) => {
    const zone = depuis?.closest('.panier-page, [data-panier-contenu]') || document;
    const m = $('[data-code-message]', zone.isConnected ? zone : document);
    if (m) m.textContent = texte;
  };
  try {
    const garde = sessionStorage.getItem('snb-code-message');
    if (garde) { sessionStorage.removeItem('snb-code-message'); const m = $('.panier-page [data-code-message]'); if (m) m.textContent = garde; }
  } catch (_) {}

  document.addEventListener('submit', async e => {
    const f = e.target.closest('[data-code-promo]');
    if (!f) return;
    e.preventDefault();
    const champ = f.elements.discount;
    const code = (champ?.value || '').trim();
    if (!code) { dire('Saisis ton code promo.', f); champ?.focus(); return; }
    const b = Array.from(f.elements).find(el => el.type === 'submit');
    b?.setAttribute('disabled', '');
    try {
      const avant = codesPoses().filter(c => c.toLowerCase() !== code.toLowerCase());
      const panier = await poserCodes([...avant, code]);
      const retour = panier?.discount_codes?.find(d => d.code.toLowerCase() === code.toLowerCase());
      const accepte = !!retour?.applicable;
      if (!accepte) await poserCodes(avant);
      if (f.hasAttribute('data-recharger')) {
        try { sessionStorage.setItem('snb-code-message', accepte ? `Code ${code.toUpperCase()} appliqué.` : `Le code ${code.toUpperCase()} n'est pas valable pour ce panier.`); } catch (_) {}
        location.reload(); return;
      }
      await rafraichirPanier();
      dire(accepte ? `Code ${code.toUpperCase()} appliqué.` : `Le code ${code.toUpperCase()} n'est pas valable pour ce panier.`, $('[data-panier-contenu]'));
    } catch (_) {
      dire("Le code n'a pas pu être vérifié. Tu pourras le saisir à l'étape du paiement.", f);
    } finally { b?.removeAttribute('disabled'); }
  });

  document.addEventListener('click', async e => {
    const el = e.target.closest('[data-retirer-code]');
    if (!el) return;
    e.preventDefault();
    const code = el.dataset.retirerCode;
    await poserCodes(codesPoses().filter(c => c !== code));
    if (el.closest('[data-recharger-codes]')) { location.reload(); return; }
    await rafraichirPanier();
    dire(`Code ${code} retiré.`, $('[data-panier-contenu]'));
  });
}

function galerie() {
  const g = $('[data-galerie]');
  if (!g) return;
  const points = $$('[data-galerie-point]', g);
  const piste = $('[data-galerie-piste]', g);
  if (!piste || !points.length) return;
  piste.addEventListener('scroll', () => {
    const i = Math.round(piste.scrollLeft / piste.clientWidth);
    points.forEach((p, k) => p.setAttribute('aria-current', String(k === i)));
  }, { passive: true });
  points.forEach((p, k) => p.addEventListener('click', () => {
    piste.scrollTo({ left: k * piste.clientWidth, behavior: 'smooth' });
  }));
}

function variantes() {
  const bloc = $('[data-variantes]');
  if (!bloc) return;
  let liste;
  try { liste = JSON.parse(bloc.textContent); } catch { return; }

  const champs = $$('[data-ajout-panier] input[name="id"]');

  const groupes = $$('.achat__option');
  const selects = $$('.fiche__option select');
  if (!champs.length || (!groupes.length && !selects.length)) return;

  const lire = () => (groupes.length
    ? groupes.map((g) => {
        const r = $('input[type="radio"]:checked', g);
        return r ? r.value : null;
      })
    : selects.map(s => s.value));

  const maj = () => {
    const choix = lire();
    if (choix.some(c => c === null)) return;
    const v = liste.find(x => x.options.length === choix.length
                              && x.options.every((o, i) => o === choix[i]));
    if (!v) return;
    champs.forEach((c) => { c.value = v.id; });
    const prix = $('.prix__valeur');
    if (prix) prix.textContent = v.prix;
    const collant = $('.fiche__collant-prix');
    if (collant) collant.textContent = v.prix;
    const bouton = $('.fiche__ajouter');
    if (bouton) {
      bouton.textContent = v.disponible ? 'Ajouter au panier' : 'Me prévenir';
      bouton.classList.toggle('bouton--ligne', !v.disponible);
    }

    const vue = $('[data-vue-variante]');
    if (vue && v.image) {
      const img = $('img', vue);
      if (img && img.getAttribute('src') !== v.image.src) {
        img.srcset = v.image.srcset;
        img.src = v.image.src;
        const vignette = $('[data-vignette-variante]');
        if (vignette) vignette.src = v.image.vignette;
        const barre = $('[data-collant-variante]');
        if (barre) barre.src = v.image.vignette;
      }
      const g = vue.closest('mvt-galerie');
      if (g && g.aller && g.vues) g.aller(g.vues.indexOf(vue));
    }

    const u = new URL(location.href);
    u.searchParams.set('variant', v.id);
    history.replaceState({}, '', u);
  };

  groupes.forEach(g => g.addEventListener('change', maj));
  selects.forEach(s => s.addEventListener('change', maj));

  const demande = new URL(location.href).searchParams.get('variant');
  if (demande) {
    const v = liste.find(x => String(x.id) === demande);
    if (v) {
      groupes.forEach((g, i) => {
        const cible = $$('input[type="radio"]', g).find(r => r.value === v.options[i]);
        if (cible) cible.checked = true;
      });
      selects.forEach((s, i) => { if (v.options[i]) s.value = v.options[i]; });
      maj();
    }
  }
}

function avantApres() {
  $$('[data-avant-apres]').forEach(bloc => {
    const curseur = $('input[type="range"]', bloc);
    const dessus = $('[data-apres]', bloc);
    if (!curseur || !dessus) return;
    const maj = () => {
      dessus.style.clipPath = `inset(0 0 0 ${curseur.value}%)`;
      curseur.setAttribute('aria-valuetext', `${curseur.value} % après`);
    };
    curseur.addEventListener('input', maj);
    maj();
  });
}

function diagnostic() {
  const d = $('[data-diagnostic]');
  if (!d) return;
  const etapes = $$('[data-diag-etape]', d);
  const reponses = {};
  let i = 0;
  const montrer = () => {
    etapes.forEach((e, k) => { e.hidden = k !== i; });
    const barre = $('[data-diag-progres]', d);
    if (barre) barre.style.setProperty('--avance', `${(i / (etapes.length - 1)) * 100}%`);
  };
  const resultat = $('[data-diag-resultat]', d);
  d.addEventListener('click', e => {
    const c = e.target.closest('[data-diag-choix]');
    if (!c) return;
    reponses[c.dataset.diagQuestion] = c.dataset.diagChoix;
    if (i < etapes.length - 1) {
      i++; montrer();
    } else {

      etapes.forEach(e2 => { e2.hidden = true; });
      $('[data-diag-retour]', d)?.setAttribute('hidden', '');
      const barre = $('[data-diag-progres]', d);
      if (barre) barre.style.setProperty('--avance', '100%');
    }
    d.dispatchEvent(new CustomEvent('diagnostic:reponse', { detail: { ...reponses } }));
  });
  $('[data-diag-retour]', d)?.addEventListener('click', () => { if (i > 0) { i--; montrer(); } });
  montrer();
}

function barreAchat() {
  const barre = document.querySelector('.fiche__collant');
  const principal = document.querySelector('.fiche__ajouter');
  if (!barre || !principal || !('IntersectionObserver' in window)) return;
  new IntersectionObserver((entrees) => {
    barre.classList.toggle('est-visible', !entrees[0].isIntersecting);
  }, { rootMargin: '0px 0px -10% 0px' }).observe(principal);
}

function demarrer() {
  header(); brancherPanneaux(); megaMenu(); accordeons(); devoilements();
  barreAchatFiche(); filtresAvis(); vusRecemment(); selecteursQuantite(); paliersQuantite();
  videos(); panier(); galerie(); variantes(); avantApres(); diagnostic();
  barreAchat();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', demarrer);
} else {
  demarrer();
}

document.addEventListener('shopify:section:load', demarrer);
document.addEventListener('shopify:section:reorder', demarrer);
document.addEventListener('shopify:block:select', demarrer);

export { ouvrir, fermer, rafraichirPanier };

function barreAchatFiche() {
  const barre = $('[data-barre-achat]');
  const bouton = $('[data-bouton-achat]');
  if (!barre || !bouton) return;
  barre.hidden = false;

  const io = new IntersectionObserver(([e]) => {
    barre.classList.toggle('est-visible', !e.isIntersecting);
  }, { rootMargin: '-110px 0px 0px 0px' });
  io.observe(bouton);
}

function filtresAvis() {
  const zone = $('[data-avis-filtres]');
  if (!zone) return;
  const cartes = $$('.avis-carte');
  $$('button', zone).forEach(b => {
    b.addEventListener('click', () => {
      const f = b.dataset.filtre;
      $$('button', zone).forEach(x => {
        x.classList.toggle('est-actif', x === b);
        x.setAttribute('aria-pressed', String(x === b));
      });
      cartes.forEach(c => {
        const garde = f === 'tous'
          || (f === 'photo' && c.dataset.photo === '1')
          || c.dataset.note === f;
        c.hidden = !garde;
      });
    });
  });
}

function vusRecemment() {
  const cle = 'snb-vus';
  let vus = [];
  try { vus = JSON.parse(localStorage.getItem(cle) || '[]'); } catch (e) { vus = []; }

  const fiche = $('[data-section] .achat__titre');
  const chemin = location.pathname;
  if (fiche && chemin.includes('/products/')) {
    vus = [chemin, ...vus.filter(v => v !== chemin)].slice(0, 8);
    try { localStorage.setItem(cle, JSON.stringify(vus)); } catch (e) {  }
  }

  const bloc = $('[data-vus]');
  const liste = $('[data-vus-liste]');
  if (!bloc || !liste) return;
  const autres = vus.filter(v => v !== chemin).slice(0, 4);
  if (!autres.length) return;

  Promise.all(autres.map(u =>
    fetch(`${u}?view=carte`, { headers: { 'X-Requested-With': 'fetch' } })
      .then(r => (r.ok ? r.text() : ''))
      .catch(() => '')
  )).then(morceaux => {
    const utiles = morceaux.filter(m => m.trim());
    if (!utiles.length) return;
    liste.innerHTML = utiles.join('');
    bloc.hidden = false;
  });
}

function paliersQuantite() {
  const bloc = $('[data-paliers]');
  const champ = $('#qte');
  if (!bloc || !champ || bloc.dataset.pret) return;
  bloc.dataset.pret = '1';
  const radios = $$('input[name="palier"]', bloc);
  radios.forEach(r => r.addEventListener('change', () => {
    if (!r.checked) return;
    champ.value = r.value;
    champ.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  champ.addEventListener('change', () => {
    radios.forEach(r => { r.checked = r.value === champ.value; });
  });
}

function selecteursQuantite() {
  $$('[data-quantite]').forEach(bloc => {
    const champ = $('.quantite__champ', bloc);
    if (!champ) return;
    const mini = Number(champ.min || 1);

    const poser = (n) => {
      const v = Math.max(mini, Math.floor(n) || mini);
      champ.value = String(v);
      $$('[data-qte]', bloc).forEach(b => {
        if (Number(b.dataset.qte) < 0) b.disabled = v <= mini;
      });
      champ.dispatchEvent(new Event('change', { bubbles: true }));
    };

    $$('[data-qte]', bloc).forEach(b => {
      b.addEventListener('click', () => poser(Number(champ.value) + Number(b.dataset.qte)));
    });
    champ.addEventListener('change', () => {
      const v = Math.max(mini, Math.floor(Number(champ.value)) || mini);
      if (String(v) !== champ.value) champ.value = String(v);
      $$('[data-qte]', bloc).forEach(x => {
        if (Number(x.dataset.qte) < 0) x.disabled = v <= mini;
      });
    });
    poser(Number(champ.value) || mini);
  });
}
